import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageContent from "../layout/PageContent";
import PostBanner from "./PostBanner";
import ImageBGSection from "../reusable/fieldGroups/ImageBGSection";
import MorePosts from "./MorePosts";
import Newsletter from "../reusable/Newsletter";
import GlobalMeta from "../reusable/GlobalMeta";
import PostForm from "./PostForm";

export default function SinglePost(){
    
    const {'*':slug}=useParams();
    const [insight, setInsight]=useState();

    //Fetch post by slug
    const { isPending, isError, data, error }=useQuery(
        ['post', slug], //Query key and dependency
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/posts?slug='+slug+'&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setInsight(data.data[0]);
        }
    },[data]);

    //console.log(insight)

    return(
        <>
         <GlobalMeta/>
            <PostBanner
                post={insight}
            />
            <PageContent
                content={insight?.content.rendered}
            />
            {insight?.acf?.form?.enabled && (
                <PostForm
                    content={insight?.acf?.form}
                    post={insight}
                />
            )}
            <ImageBGSection
                content={insight?.acf.image_background}
            />
            <MorePosts
                currentPost={insight?.id}
            />
            <Newsletter/>
        </> 
    )
}